/* Keep purchase controls above Shopify's consent banner without changing consent. */
(() => {
  let frame;
  let observedBanner;
  const resizeObserver = new ResizeObserver(schedule);
  function update() {
    frame = null;
    const banner = document.getElementById('shopify-pc__banner');
    if (banner !== observedBanner) {
      resizeObserver.disconnect();
      observedBanner = banner;
      if (banner) resizeObserver.observe(banner);
    }
    const rect = banner?.getBoundingClientRect();
    const visible = banner && getComputedStyle(banner).visibility !== 'hidden' && rect.height > 0;
    const inset = visible ? Math.max(0, window.innerHeight - rect.top + 8) : 0;
    const value = `${Math.ceil(inset)}px`;
    if (document.documentElement.style.getPropertyValue('--aleona-consent-inset') !== value) {
      document.documentElement.style.setProperty('--aleona-consent-inset', value);
      document.dispatchEvent(new Event('aleona:purchase-inset'));
    }
  }
  function schedule() {
    if (!frame) frame = requestAnimationFrame(update);
  }
  // Banner nodes are injected asynchronously and removed after a consent choice.
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  window.addEventListener('resize', schedule, { passive: true });
  document.addEventListener('visitorConsentCollected', schedule);
  update();
})();
